import type { WorkbenchStatus } from './statusScope';

/** Die Handlung hinter dem ersten Knopf der Aktionsleiste. */
export type PrimaryAction = 'accept' | 'edit' | 'reopen';
/** Die Handlung hinter dem zweiten Knopf. */
export type SecondaryAction = 'reject' | 'withdrawApproval' | 'edit';

export interface StatusActionSet {
  primary: PrimaryAction;
  secondary: SecondaryAction;
  /**
   * Ob Enter und Leertaste die beiden Handlungen ausloesen duerfen.
   *
   * Nur im Reiter "Offen". Der Schnelldurchlauf per Tastatur ist dort das
   * gewollte Arbeitstempo; in den anderen beiden Reitern ist dasselbe
   * Muskelgedaechtnis eine Gefahr — Enter wuerde ein bereits ausgeliefertes
   * Produkt anfassen, ohne dass jemand hinsieht.
   */
  keyboardEnabled: boolean;
  /**
   * Ob die zweite Handlung eine Rueckfrage braucht.
   *
   * Genau einmal wahr, beim Zuruecknehmen einer Freigabe. Das ist der Weg
   * fuer den Versehensfall, nicht der Normalweg (der ist Bearbeiten). Eine
   * Rueckfrage an jeder Aktion wird nach dem dritten Mal blind weggeklickt
   * und schuetzt danach gar nichts mehr.
   */
  confirmSecondary: boolean;
}

const ACTION_SETS: Record<WorkbenchStatus, StatusActionSet> = {
  pending: {
    primary: 'accept',
    secondary: 'reject',
    keyboardEnabled: true,
    confirmSecondary: false,
  },
  approved: {
    primary: 'edit',
    secondary: 'withdrawApproval',
    keyboardEnabled: false,
    confirmSecondary: true,
  },
  rejected: {
    primary: 'reopen',
    secondary: 'edit',
    keyboardEnabled: false,
    confirmSecondary: false,
  },
};

/**
 * Welche Handlungen ein Reiter anbietet.
 *
 * Als eigenes Modul und nicht als Verzweigung in der Aktionsleiste, weil zwei
 * Stellen dieselbe Antwort brauchen und sie nicht auseinanderlaufen duerfen:
 * die Leiste rendert die Knoepfe, der Reviewer entscheidet daraus, ob sein
 * globaler Tastatur-Handler ueberhaupt greift. Genau diese Doppelung war der
 * Grund, warum eine frueher gebaute Tastatursperre nur die Knoepfe abschaltete
 * und die Tasten weiterlaufen liess.
 */
export function actionSetFor(status: WorkbenchStatus): StatusActionSet {
  return ACTION_SETS[status];
}
